// extracted by mini-css-extract-plugin
export default {"card":"Card_card__zQfcO","title":"Card_title__fjt9r","subtitle":"Card_subtitle__KA6uV","footer":"Card_footer__d0BFV"};